<template>
  <div id="app-news">
    <div class="news-box">
      <div class="news-top">
        <span></span>
        <div class="top-l">
          <p>NEWS</p>
          <h3>新闻动态</h3>
        </div>
        <div class="top-r">
          <ul>
            <router-link
              tag="li"
              v-for="(item,index) in navData"
              :key="index"
              :to="{name:item.url,query:item.params}"
            >{{item.title}}</router-link>
          </ul>
          <router-link tag="i" :to="{name:channel.url,query:channel.params}"></router-link>
        </div>
      </div>

      <WtDataList
        v-model="news.list"
        :pageSize="5"
        :url="$url.news.list"
        :search="ifSearch"
        :isPage="false"
      >
        <div class="news-bottom" slot="list">
          <ul>
            <router-link
              tag="li"
              v-for="(item,index) in news.list"
              :key="index"
              :to="{ name: 'newsInfo',query: { id: item.id }}"
            >
              <img :src="item.cover_photo_text[0].path" v-if="item.cover_photo" />
              <div class="news-box">
                <div class="b-left">
                  <h3>{{dateFormat(item.publish_time,'MM-dd')}}</h3>
                  <p>{{dateFormat(item.publish_time,'yyyy')}}</p>
                </div>
                <div class="b-right">
                  <h3>{{item.title}}</h3>
                  <p>{{item.description}}</p>
                </div>
              </div>
            </router-link>
          </ul>
        </div>
      </WtDataList>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    //请求的url地址
    modelId: {
      type: Number,
      default() {
        return 0;
      }
    }
  },
  data() {
    return {
      news: {},
      ifSearch: {
        if_recommend: 1, //首页推荐
        if_show: 1, //前台展示
        type: 1
      },
      navData: [],
      channel: {},
      listyle: 1,
      
    };
  },
  mounted() {},
  watch: {
    modelId(val) {
      //查询该分类下的所有子分类
      let params = {
        pid: val
      };
      this.$db.post(this.$url.website.channel.list, params).then(resp => {
        if (resp && resp.data) {
          var newsNav = resp.data;
          newsNav.forEach(element => {
            switch (element.model) {
              case "url": //外链
                break;
              case "news":
              case "yuebao":
              case "photos":
                if (element.type == "list") {
                  element.url = "news";
                  element.params = {
                    cate_id: element.cate_id,
                    moduleId: val,
                    model: element.model
                  };
                } else {
                  element.url = "newsInfo";
                  element.params = {
                    id: element.value_id
                  };
                }
                break;
              case "project":
                if (element.type == "all") {
                  element.url = "projects";
                  element.params = {
                    moduleId: val
                  };
                } else {
                  element.url = "projectInfo";
                }
                break;
              case "activity":
                if (element.type == "all") {
                  element.url = "activitys";
                  element.params = {
                    moduleId: val
                  };
                } else {
                  element.url = "activityInfo";
                }
                break;
              case "about":
                element.url = "aboutInfo";
                element.params = {
                  moduleId: val,
                  id: element.value_id
                };
                break;
              default:
                element.url = "home";
                break;
            }
          });
          this.navData = newsNav;
        }
      });
      //查询当前分类，组成url
      this.$db.get(this.$url.website.channel.url + "/" + val).then(resp => {
        this.channel = resp.data;
        switch (this.channel.model) {
          case "url": //外链
            break;
          case "news":
          case "yuebao":
          case "photos":
            if (this.channel.type == "list") {
              this.channel.url = "news";
              this.channel.params = {
                cate_id: this.channel.cate_id,
                moduleId: val,
                model: this.channel.model
              };
            } else {
              this.channel.url = "newsInfo";
              this.channel.params = {
                id: this.channel.value_id
              };
            }
            break;
          case "project":
            if (this.channel.type == "all") {
              this.channel.url = "projects";
              this.channel.params = {
                moduleId: val
              };
            } else {
              this.channel.url = "projectInfo";
            }
            break;
          case "activity":
            if (this.channel.type == "all") {
              this.channel.url = "activitys";
              this.channel.params = {
                moduleId: val
              };
            } else {
              this.channel.url = "activityInfo";
            }
            break;
          case "about":
            this.channel.url = "aboutInfo";
            this.channel.params = {
              moduleId: val,
              id: this.channel.value_id
            };
            break;
          default:
            this.channel.url = "home";
            break;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
#app-news {
  width: 100%;
  margin-bottom: 45px;
}
.news-box {
  max-width: 1300px;
  margin: 0 auto;
  .news-top {
    position: relative;
    padding-left: 18px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 45px;
    > span {
      width: 2px;
      // height: 55px;
      height: 100%;
      background-image: linear-gradient(
          0deg,
          #8ec31f 0%,
          #4eb875 10%,
          #2dbadc 20%,
          #258bcc 31%,
          #273d96 43%,
          #944496 50%,
          #bb4695 53%,
          #dc0536 65%,
          #e83a16 76%,
          #fcd475 89%,
          #d7de00 100%
        ),
        linear-gradient(#c12411, #c12411);
      position: absolute;
      left: 0;
      top: 0;
    }
    .top-l {
      > p {
        font-size: 24px;
        font-weight: normal;
        color: #999999;
      }
      > h3 {
        font-size: 24px;
        font-weight: 500;
        color: #333;
      }
    }
    .top-r {
      padding-right: 25px;
      position: relative;
      //width: 308px;
      > ul {
        display: flex;
        justify-content: space-between;
        position: relative;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        > li {
          list-style: none;
          margin-right: 30px;
          font-size: 15px;
          font-weight: normal;
          color: #333333;
          padding-bottom: 3px;
          cursor: pointer; // &:last-child { // margin-right: 0; // }
          &.active {
            border-bottom: 2px solid #e83a16;
            color: #e83a16;
          }
        }
      }
      > i {
        width: 25px;
        height: 25px;
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
        background: url(../../assets/images/more.png) no-repeat;
        background-size: 100% 100%;
        &:hover {
          background: url(../../assets/images/more1.png) no-repeat;
          background-size: 100% 100%;
        }
      }
    }
  }
  .news-bottom {
    width: 100%;
    > ul {
      padding-left: 588px;
      position: relative;
      > li {
        list-style: none;
        border-top: 1px solid #eee;
        cursor: pointer;
        &:hover {
          .news-box {
            .b-right {
              > p {
                color: #e83a16;
              }
              > h3 {
                color: #e83a16;
              }
            }
            .b-left {
              > p {
                color: #e83a16;
              }
              > h3 {
                color: #e83a16;
              }
            }
          }
        }
        &:last-child {
          border-bottom: 1px solid #eee;
        }
        &:first-child {
          position: absolute;
          top: 0;
          left: 0;
          > img {
            width: 500px;
            height: 281px;
            margin-bottom: 28px;
            border-radius: 6px;
          }
          .news-box {
            padding: 0;
            padding-left: 87px;
            padding-top: 10px;
            .b-right {
              width: 394px;
              padding-left: 8px;
              border-left: 1px solid #eee;
              > p {
                font-size: 14px;
                overflow: visible;
                white-space: normal;
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
              }
            }
          }
        }
        > img {
          width: 0;
          height: 0;
        }
        .news-box {
          padding: 22px 0px 28px 120px;
          position: relative;
          padding-top: 8px;
          .b-left {
            width: 76px;

            height: 41px;
            position: absolute;
            top: 10px;
            left: 0;
            text-align: right;
            > h3 {
              font-size: 24px;
              font-weight: normal;
              color: #999999;
            }
            > p {
              font-size: 14px;
              font-weight: normal;
              color: #999999;
            }
          }
          .b-right {
            > h3 {
              font-size: 16px;
              font-weight: normal;
              color: #333333;
              margin-bottom: 6px;
              overflow: hidden; /* 超出部分隐藏 */
              white-space: nowrap;
              /* 不换行 */
              text-overflow: ellipsis;
              /* 超出部分省略号显示 */
            }
            > p {
              font-size: 14px;
              font-weight: normal;
              color: #999999;
              overflow: hidden;
              /* 超出部分隐藏 */
              white-space: nowrap;
              /* 不换行 */
              text-overflow: ellipsis;
              /* 超出部分省略号显示 */
            }
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/Index/news.vue